<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6">{{ dialog_title }}</span>
                    <div class="text-caption">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form">
                    <v-row dense>
                        <v-col class="text-right" cols="12">
                            <v-btn
                                @click="printAMSForm1()"
                                prepend-icon="mdi-printer"
                                class="mt-1 rounded-lg ml-md-2"
                                color="orange-darken-3"
                                height="40px"
                                elevation="2">
                                    Print AMS Form 1
                            </v-btn>
                            <v-btn
                                @click="showAddDialog()"
                                prepend-icon="mdi-plus"
                                class="mt-1 rounded-lg ml-md-2"
                                color="routesColor"
                                height="40px"
                                elevation="2">
                                    Add Details
                            </v-btn>
                        </v-col>
                        <v-col cols="12" class="mt-2">
                            <v-card class="dt-container">    
                                <v-data-table
                                    :mobile="isMobileOrTablet()"
                                    :headers="headers"
                                    :items="data"
                                    :loading="loading"
                                    :items-per-page="15"
                                    :items-per-page-options="[15,30, 50, 100, -1]"
                                >
                                <template v-slot:loading>
                                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                </template>
                                <template v-slot:item.title="{ item }">
                                    <div class="text-truncate" style="max-width: 150px;">
                                        {{ item.title }}
                                    </div>
                                </template>
                                <template v-slot:item.is_approved="{ item }">
                                    <v-chip v-if="item.is_approved == true" size="small" color="green" variant="elevated">
                                        Yes
                                    </v-chip>
                                    <v-chip v-else size="small" color="gray">
                                        No
                                    </v-chip>
                                </template>
                                <template v-slot:item.date_submitted="{ item }">
                                    <span>{{ formatDate(item.date_submitted)}} </span>
                                </template>
                                <template v-slot:[`item.action`]="{ item }">
                                    <div  class="d-flex justify-end ga-2">
                                        <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                        <v-btn  @click="showDeleteDialog(item)" size="small" variant="outlined" text="Remove" color="red" elevation="3"></v-btn>
                                    </div>
                                </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Close" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDelete" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want remove this AMS Form 1 detail?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDelete = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deleteDetails()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <ComplianceMatrixDetailsDialog ref="CheckingComplianceDialog" @refresh="initDetails()" />

</template>

<script>
import { defineComponent } from 'vue'
import ComplianceMatrixDetailsDialog from './Sub-Dialogs/ComplianceMatrixDetailsDialog.vue';
import { generateComplianceMatrixPDF } from '../../composables/pdf/compliance-matrix-pdf';
import { useSnackbar } from '@/composables/useSnackbar';

export default defineComponent({
    emits: ["refresh"],
    components: {
        ComplianceMatrixDetailsDialog
    },
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,
            data: [],

            headers: [
                { title: 'Concerns/Issues', align: 'start', sortable: true, key: 'concerns' },
                { title: 'Institutes', align: 'start', sortable: true, key: 'institutes' },
                { title: 'Recommendations/Actions', align: 'start', sortable: true, key: 'recommendations' },
                { title: 'Compliance/Agreement', align: 'start', sortable: true, key: 'agreement'},
                { title: 'Date Complied', align: 'start', sortable: true, key: 'date_complied'},
                { title: 'Remarks', align: 'start', sortable: true, key: 'remarks'},
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            confirmDelete: false,
            itemToDelete: null,

            complianceMatrixData: null,
        }
    },
    methods: {
        async initViewDetails(data){
            this.dialog = true
            this.dialog_title = 'AMS Form 1 Details'
            this.dialog_sub_title = data.agenda
            this.action = 'view'

            this.complianceMatrixData = data

            await this.initDetails()
        },
        async initDetails() {
            this.loading = true;
            let res = await this.axiosCall('/compliance-matrix-details/findAllByComplianceMatrix/' + this.complianceMatrixData.id, 'get', null, true);
            if (res && res.data) {
                this.data = res.data;
                this.loading = false;
                if (!this.data || this.data.length === 0) {
                    await this.initReportDetails();
                }
            }
        },
        async initReportDetails() {
            this.loading = true;
            let res = await this.axiosCall('/reports/generateAMSForm1Report/' + this.$store.state.semester_schoolyear.id, 'get', null, true);
            if (res && res.data) {
                const matrix = res.data.matrix;
                for (const row of matrix) {
                    await this.axiosCall('/compliance-matrix-details', 'post', {
                        compliance_matrix_id: this.complianceMatrixData.id,
                        concerns: row.concerns,
                        institutes: row.institutes,
                        recommendations: row.recommendations,
                        agreement: row.agreement,
                        date_complied: row.date_complied,
                        remarks: row.remarks,
                        status: true
                    }, true);
                }
                await this.initDetails();
            }
            this.loading = false;
        },
        deleteDetails(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            this.axiosCall('/compliance-matrix-details/' + this.itemToDelete.id, 'delete', null, true)
            .then(res => {
                if(res.data.status == 200){
                    this.loading = false
                    this.confirmDelete = false
                    this.initDetails()
                    showSnackbar('AMS Form 1 detail successfully removed!')
                }
            })
        },
        showAddDialog(){
            this.$refs.CheckingComplianceDialog.initAdd(this.complianceMatrixData)
        },
        showEditDialog(data){
            this.$refs.CheckingComplianceDialog.initUpdate(data)
        },
        showDeleteDialog(data){
            this.itemToDelete = data
            this.confirmDelete = true
        },
        printAMSForm1(){
            generateComplianceMatrixPDF(this.complianceMatrixData, this.data)
        },
        closeDialog(){
            this.user = []
            this.$emit('refresh')
            this.dialog = false
        },
    }
})
</script>

<style scoped>

</style>